export const Footer =() => {
    return (
        <div className="footer">
            <p>
                <p>&copy; 2025 Arthur International Agency (AIA). All rights reserved.</p>
            </p>
        </div>
    )
}